document.addEventListener('DOMContentLoaded', () => {
  const scrollBtn = document.getElementById('scrollToTop');
  const progress = document.getElementById('scrollProgress');
  if (!scrollBtn || !progress?.r?.baseVal) return;
  const radius = progress.r.baseVal.value;
  const circumference = 2 * Math.PI * radius;

  progress.style.strokeDasharray = circumference;
  progress.style.strokeDashoffset = circumference;

  const updateProgress = () => {
    const scrollTop = window.scrollY;
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    const percent = scrollHeight ? scrollTop / scrollHeight : 0;
    const offset = circumference - percent * circumference;

    progress.style.strokeDashoffset = offset;
    scrollBtn.style.display = scrollTop > 300 ? 'flex' : 'none';
  };

  // Throttle function
  const throttle = (func, limit) => {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if ((Date.now() - lastRan) >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  };

  const scrollToTop = (e) => {
  e.preventDefault();

  const duration = 1000; // in ms
  const start = window.scrollY;
  const startTime = performance.now();

  const animateScroll = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = 1 - Math.pow(1 - progress, 3); // ease-out cubic

    window.scrollTo(0, start * (1 - ease));

    if (elapsed < duration) {
      requestAnimationFrame(animateScroll);
    }
  };

  requestAnimationFrame(animateScroll);
};


  window.addEventListener('scroll', throttle(updateProgress, 100), { passive: true });
  scrollBtn.addEventListener('click', scrollToTop);

  updateProgress();
});
